<template>
    <body class="">
        <!-- header -->
        <header id="header">
            <div class="container">
                <div class="nav">
                    <button class="btn btn-nav" @click="fn_gnbShow()">
                        <span class="blind">메뉴</span>
                    </button>
                    <button class="btn btn-back" @click="backbtn()">
                        <span class="blind">뒤로가기</span>
                    </button>
                </div>
                <div class="title">
                    <!-- <a ><img src="/images/common/img_logo.png" alt=""></a> -->
                    <span>NATM Slide Show</span>
                </div>
            </div>
        </header>
        <!-- // header -->

        <!-- gnb -->
        <gnb :gnb-on="gnbShow" @getChildGnbShow="getChildGnbShow" />
        <div class="gnb-dimmed" :class="gnbShow" @click="getChildGnbShow()" />
        <!-- // gnb -->

        <div id="content-wrap">
            <div id="contents">
                <!-- step info -->
                <div class="list-info-wrapper">
                    <div class="container">
                        <ul>
                            <li @click="movePage('List')">
                                <span>페이스맵핑목록</span>
                            </li>
                            <li @click="movePage('SlideNATM')">
                                <span>NATM슬라이드</span>
                            </li>
                            <li class="on" @click="movePage('SlideTBM')">
                                <span>TBM슬라이드</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- // step info -->

                <div class="list-slide-wrapper">
                    <div class="swiper-container">
                        <div class="swiper-wrapper">
                            <swiper :options="swiperOption">
                                <swiper-slide v-for="(data, index) in datas" :key="index" class="swiper-slide">
                                    <div class="swiper-slide">
                                        <div class="slide-box">
                                            <div class="slide-header">
                                                <p class="tit">
                                                    {{ data.station }}
                                                </p>
                                            </div>
                                            <div class="slide-body" @click="selectImg(data)">
                                                <div class="image-box" style="height:270px">
                                                    <img :src="fileUrl + data.tbmLeftImageUrl" @error="imgError" />
                                                </div>
                                                <div class="image-box" style="height:270px">
                                                    <img :src="fileUrl + data.tbmRightImageUrl" @error="imgError" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </swiper-slide>
                                <div slot="pagination" class="swiper-pagination" />
                            </swiper>
                        </div>
                        <div class="swiper-button-prev" />
                        <div class="swiper-button-next" />
                    </div>
                </div>
            </div>
        </div>
        <slidePop :param="slideParam" />
    </body>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import { mapActions, mapState } from 'vuex';
import FacemappingApi from '../api/FacemappingApi';
import { FILE_URL, NO_IMG, PAGINATION, TUNNEL_CONSTRUCTION } from '../const';
import slidePop from './common/SlidePop.vue';
import gnb from './layout/gnb.vue';

export default {
    name: 'SlideTBM',
    components: {
        gnb,
        slidePop,
        swiper,
        swiperSlide
    },
    data: () => {
        return {
            datas: {},
            param: {
                page: PAGINATION.number,
                rows: 10000,
                sort: 'investigationDay desc,reg_dt',
                direction: 'desc',
                geologist: '',
                investigationDay: '',
                tunnelConstructionMethod: TUNNEL_CONSTRUCTION.TBM
            },
            gnbShow: '',
            swiperOption: {
                direction: 'horizontal',
                slidesPerView: 'auto',
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction'
                },
                navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }
            },
            fileUrl: FILE_URL,
            slideParam: {
                data: {},
                isShow: false
            }
        };
    },
    computed: {
        ...mapState({})
    },
    beforeCreate() {},
    created() {},
    mounted() {
        //setLandscape();
        this.list();
    },
    beforeDestroy() {},
    methods: {
        ...mapActions(['showLoading', 'hideLoading', 'alert']),
        backbtn() {
            this.$router.go(-1);
        },
        imgError(e) {
            e.target.src = NO_IMG;
        },
        fn_gnbShow() {
            this.gnbShow = 'on';
            $('html').addClass('off');
        },
        getChildGnbShow() {
            this.gnbShow = '';
            $('html').removeClass('off');
        },
        list() {
            this.showLoading();
            FacemappingApi.list(this.param).then(res => {
                this.hideLoading();
                this.datas = res.content;
            });
        },
        movePage(target) {
            this.$router.push({
                name: target
            });
        },
        selectImg(data) {
            this.slideParam.data = data;
            this.slideParam.isShow = true;
        }
    }
};
/*
#wrap > div {
    height: inherit;
}
*/
</script>
